<form [formGroup]="reqAzForm">

<div class="ontario-row">
    <div class="ontario-column ontario-small-12">
        <input type="hidden" name="menuType" id="menuType" value="secure"/>
        <h2 id="pageTitle">{{ 'bss.reqAuthorize.title' | translate }}</h2>
        <hr>
        
        <p [innerHTML]="'bss.reqAuthorize.subTitle' | translate:{resourceUrl: resourceUrl}"></p>
          
        <div class="ontario-row">
            <dl><dt></dt><dd>
            <div class="ontario-columns ontario-small-12 ontario-medium-4">
                <label class="ontario-label" for="adminemail">
                {{'bss.reqAuthorize.emailAddress' | translate }} <span class="ontario-label__flag"> ({{'bss.reqAuthorize.required' |
                    translate }})</span>
                </label>
            </div>
            <div class="ontario-columns ontario-small-12 ontario-medium-8">
                <input tabindex="101" class="ontario-input ontario-input--20-char-width" type="text" id="adminemail"
                title="{{'bss.reqAuthorize.emailAddress.input.title' | translate }}" aria-describedby="emailError" formControlName="adminemail">
    
                <div *ngIf="(reqAzForm.get('adminemail').touched || reqAzForm.get('adminemail').dirty || submitted) && reqAzForm.get('adminemail').errors?.['required']" id="emailError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error">
                <ul>
                    <li>{{'bss.reqAuthorize.error.email.required' | translate }} </li>
                </ul>
                </div>
    
                <div *ngIf="(reqAzForm.get('adminemail').touched && reqAzForm.get('adminemail').invalid) && (reqAzForm.get('adminemail')?.hasError('email') || reqAzForm.get('adminemail')?.hasError('invalidEmail'))"
                id="emailError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error">
                <ul>
                    <li>{{'bss.reqAuthorize.error.email.invalid' | translate }} </li>
                </ul>
                </div>
    
            </div>
            </dd></dl>
            </div>
    
        <div class="ontario-row">
            <dl><dt></dt><dd>
            <div class="ontario-columns ontario-small-12 ontario-medium-4">
                <label class="ontario-label" for="confirmadminemail">
                {{'bss.reqAuthorize.confirmEmail' | translate }} <span class="ontario-label__flag"> ({{'bss.reqAuthorize.required' |
                    translate }})</span>
                </label>
            </div>
            <div class="ontario-columns ontario-small-12 ontario-medium-8">
                <input tabindex="102" class="ontario-input ontario-input--20-char-width" aria-describedby="confirmEmailError" type="text" id="confirmadminemail"
                title=" {{'bss.reqAuthorize.confirmEmail.input.title' | translate }}" formControlName="confirmadminemail">
    
                <div *ngIf="(submitted || reqAzForm.get('confirmadminemail').dirty || reqAzForm.get('confirmadminemail').touched) && (reqAzForm.hasError('mismatchEmail') || reqAzForm.get('confirmadminemail').errors?.['required']) " id="confirmEmailError" role="alert" aria-live="assertive" class="ontario-alert ontario-alert--error">  
    
                <div *ngIf="(reqAzForm.get('confirmadminemail').errors?.['required'])">
                    <ul>
                    <li>{{'bss.reqAuthorize.error.confirmEmail.required' | translate }} </li>
                    </ul>
                </div>
                
                <div *ngIf="reqAzForm.hasError('mismatchEmail')">
                    <ul>
                    <li>{{'bss.reqAuthorize.error.confirmEmail.mismatch' | translate }} </li>
                    </ul>
                </div>
                </div>    
            </div>
            </dd></dl>
        </div>

        <div class="ontario-row">
            <dl><dt></dt><dd>
            <div class="ontario-column ontario-small-12">
                <button tabindex="103" class="ontario-button" [ngClass]="{'ontario-button--primary': !isSubmitting}"
                title=" {{'bss.reqAuthorize.button.submit.title' | translate }}" (click)="onSubmit()" [disabled]="isSubmitting">
                {{'bss.reqAuthorize.button.submit' | translate }}
                </button>

                <button tabindex="104" class="ontario-button ontario-button--secondary" title=" {{'bss.reqAuthorize.button.cancel.title' | translate }}"
                (click)="onCancel()">
                {{'bss.reqAuthorize.button.cancel' | translate }}
                </button>
            </div>
            </dd></dl>        
        </div>    
        <p>{{ 'bss.reqAuthorize.subTitle-1' | translate }}</p>
    </div>
</div>
</form>

  
